<template>
  <div class="liquidity-calc-vehicle-debt">
    <v-row no-gutters>
      <v-col cols="12" sm="8" md="9">
        <p class="field-label mb-0">
          <b>Outstanding hire purchase debt:</b> {{ vehicle.displayName }}
        </p>
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="3"
        :class="{ 'mt-6': $vuetify.breakpoint.smAndDown }"
      >
        <ValidationProvider
          :id="'outstanding_debt' + vehicle.id"
          v-slot="{ errors }"
          :vid="'outstanding_debt' + vehicle.id"
          name="outstanding_debt"
          rules="required"
        >
          <TextField
            v-model="currencyOutstandingDebt"
            :prefix="'R'"
            :pattern="'[0-9\s]*'"
            @keypress="isNumber($event)"
            @input="handleInput"
            :errors="errors"
            :name="'outstanding_debt'"
          />
        </ValidationProvider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import {
    formatCurrency,
    parseCurrency,
    isNumberCheck,
  } from '../../constants/js/currency-input';

  export default {
    name: 'VehicleOutstandingDebt',
    props: {
      vehicle: {
        required: true,
        type: Object,
      },
      value: {
        required: true,
      },
    },
    data() {
      return {
        outstandingDebt: this.value ? this.value['outstandingDebt'] : null,
      };
    },
    computed: {
      currencyOutstandingDebt: {
        get: function () {
          return formatCurrency(this.outstandingDebt);
        },
        set: function (newValue) {
          this.outstandingDebt = parseCurrency(newValue);
        },
      },
    },
    created() {
      this.handleInput(null);
    },
    methods: {
      handleInput(_e) {
        this.$emit('input', { outstandingDebt: this.outstandingDebt });
      },
      isNumber(event) {
        isNumberCheck(event);
      },
    },
  };
</script>

<style lang="scss">
  .liquidity-calc-vehicle-debt {
    .v-input__slot {
      margin-bottom: 0;
    }

    .field-label {
      margin-top: 22px !important;
    }
  }
</style>
